import { render, staticRenderFns } from "./property-config-view.vue?vue&type=template&id=63c367b8"
import script from "./property-config-view.vue?vue&type=script&lang=js"
export * from "./property-config-view.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports